import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProcessorCloserReassignmentService } from './processor-closer-reassignment.service';

@Component({
    selector: 'app-processor-closer-pipeline-reassignment',
    templateUrl: './processor-closer-pipeline-reassignment.component.html',
    styleUrls: ['./processor-closer-pipeline-reassignment.component.css']
})
export class ProcessorCloserPipelineReassignmentComponent implements OnInit {

    public pcReassignmentForm: FormGroup;
    public reassignmentMethodControl = new FormControl();
    public reassignmentMethodValue = null;
    public processorPendingLoanCount = 0;
    public closerPendingLoanCount = 0;
    public persona = null;
    public isLoading: boolean = false;
    public inputMessage: string = "";

    public reassignmentMethods = ['Reassign Processor',
        'Reassign Closer',
        'Pending Loans - Processor',
        'Pending Loans - Closer'
    ];

    constructor(
        public processorCloserReassignmentService: ProcessorCloserReassignmentService,
        private fb: FormBuilder,
    ) {
        this.createForm();
    }

    async ngOnInit() {
        this.isLoading = true;
        this.inputMessage = "Fetching pending loans count, please wait...";
        await this.getProcessorPendingLoans();
        await this.getCloserPendingLoans();
        this.inputMessage = "";
    }

    async getProcessorPendingLoans() {
        await this.processorCloserReassignmentService.getProcessorPendingLoans().then(
            loans => {
                if (loans != null && loans != undefined) {
                    if (loans.length > 0) {
                        this.processorPendingLoanCount = loans.length;
                    }
                }
                this.isLoading = false;
            }).catch(error => {
                console.log(error)
                this.isLoading = false;
            });
    }

    async getCloserPendingLoans() {
        await this.processorCloserReassignmentService.getCloserPendingLoans().then(
            loans => {
                if (loans != null && loans != undefined) {
                    if (loans.length > 0) {
                        this.closerPendingLoanCount = loans.length;
                    }
                    this.isLoading = false;
                }
            }).catch(error => {
                console.log(error)
                this.isLoading = false;
            });
    }

    createForm() {
        this.pcReassignmentForm = this.fb.group({
            reassignmentMethodControl: [null, Validators.required],
        });
    }

    onChange(event) {
        this.reassignmentMethodValue = event.value;
        if (this.reassignmentMethodValue == 'Pending Loans - Processor') {
            this.persona = 'Processor';
        }
        else if (this.reassignmentMethodValue == 'Pending Loans - Closer') {
            this.persona = 'Closer';
        }
    }

    updateProcessorPendingLoanCount(event) {
        this.processorPendingLoanCount = event;
    }

    updateCloserPendingLoanCount(event) {
        this.closerPendingLoanCount = event;
    }

    resetSelection() {
        this.pcReassignmentForm.reset();
        this.getProcessorPendingLoans();
        this.getCloserPendingLoans();
        this.reassignmentMethodValue = null;
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/processor-closer-pipeline-reassignment/processor-closer-pipeline-reassignment.component.ts